module.exports = __webpack_public_path__ + "img/character-drawing-dog.0c098dfa.png";